import React from 'react';
import { Lock, Zap, Shield, CreditCard } from 'lucide-react';
import { Section, CTAButton } from './Shared';
export const EmotionalClose = () => {
  return <Section className="max-w-4xl" data-id="element-39">
      <div className="glass-panel p-6 md:p-12 rounded-3xl text-center bg-white/90 border-brand-celeste/30 shadow-lg relative overflow-hidden" data-id="element-40">
        <div className="absolute top-0 left-0 w-24 h-24 bg-brand-celeste/10 rounded-br-full -z-10" data-id="element-41"></div>
        <div className="absolute bottom-0 right-0 w-24 h-24 bg-brand-green/10 rounded-tl-full -z-10" data-id="element-42"></div>

        <h2 className="text-2xl md:text-4xl font-display font-bold mb-8 text-brand-greenDark leading-tight" data-id="element-43">
          Hay dos versiones de vos en este momento.
        </h2>

        <div className="space-y-5 text-base md:text-lg text-brand-text/80 mb-10 max-w-2xl mx-auto" data-id="element-44">
          <p data-id="element-45">
            Una que cierra esta página y la próxima sesión sigue improvisando,
            dudando, sin protocolo.
          </p>
          <p className="font-medium text-brand-green" data-id="element-46">
            Y otra que decide que hoy es el día en que su consultorio cambia.
          </p>
          <p className="font-serif italic text-lg md:text-xl text-brand-celesteDark" data-id="element-47">
            La pregunta no es si podés pagarlo.
            <br data-id="element-48" />
            La pregunta es cuántas sesiones más vas a improvisar.
          </p>
        </div>

        <h3 className="text-xl md:text-3xl font-display font-bold mb-8 text-brand-greenDark" data-id="element-49">
          ¿CON CUÁL EMPEZÁS?
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 mb-10" data-id="element-50">
          {/* Plan 1 */}
          <div className="glass-panel rounded-2xl p-6 md:p-7 border-brand-celeste/30 bg-white/85 text-center flex flex-col" data-id="element-51">
            <h4 className="font-serif font-bold text-lg md:text-xl text-brand-greenDark mb-1" data-id="element-52">
              📘 KIT MEDICINA TRADICIONAL CHINA
            </h4>
            <div className="text-3xl md:text-4xl font-bold text-brand-greenDark mb-3" data-id="element-53">
              $19.990
            </div>
            <p className="text-sm text-brand-text/70 mb-5 flex-grow" data-id="element-54">
              1 Tomo + 4 Bonus · 154 páginas. Aplicá protocolos probados desde
              hoy.
            </p>
            <CTAButton fullWidth className="text-sm md:text-base py-3.5" href="#pricing" variant="gold" data-id="element-55">
              📘 → LO QUIERO $19.990
            </CTAButton>
          </div>

          {/* Plan 2 — featured */}
          <div className="glass-panel rounded-2xl p-6 md:p-7 border-2 border-brand-green bg-white/95 text-center flex flex-col relative shadow-[0_10px_30px_rgba(15,118,110,0.18)]" data-id="element-56">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-brand-green text-white text-[10px] md:text-xs font-bold px-3 py-1 rounded-full whitespace-nowrap" data-id="element-57">
              ⭐ MÁS ELEGIDO
            </div>
            <h4 className="font-serif font-bold text-lg md:text-xl text-brand-green mb-1 mt-2" data-id="element-58">
              🏆 KIT MTC + MAESTRÍA EN CONSULTA
            </h4>
            <div className="text-3xl md:text-4xl font-bold text-brand-green mb-3" data-id="element-59">
              $27.990
            </div>
            <p className="text-sm text-brand-text/70 mb-5 flex-grow" data-id="element-60">
              1 Tomo + 4 Bonus + Maestría · 199 páginas. Dominá la clínica Y el
              consultorio.
            </p>
            <CTAButton fullWidth className="text-sm md:text-base py-3.5" href="#pricing" variant="purple" data-id="element-61">
              🏆 → LO QUIERO $27.990
            </CTAButton>
          </div>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs md:text-sm text-brand-muted mb-8" data-id="element-62">
          <div className="flex items-center" data-id="element-63">
            <Lock className="w-3.5 h-3.5 md:w-4 md:h-4 mr-1.5" data-id="element-64" /> Pago 100%
            seguro
          </div>
          <div className="flex items-center" data-id="element-65">
            <Zap className="w-3.5 h-3.5 md:w-4 md:h-4 mr-1.5" data-id="element-66" /> Acceso en 5
            minutos
          </div>
          <div className="flex items-center" data-id="element-67">
            <Shield className="w-3.5 h-3.5 md:w-4 md:h-4 mr-1.5" data-id="element-68" /> Garantía 7
            días
          </div>
          <div className="flex items-center" data-id="element-69">
            <CreditCard className="w-3.5 h-3.5 md:w-4 md:h-4 mr-1.5" data-id="element-70" /> Mercado
            Pago | Tarjeta | Transferencia
          </div>
        </div>

        <div className="text-sm text-brand-text/70 bg-brand-surfaceLight/60 p-5 md:p-6 rounded-2xl border border-brand-celeste/20 space-y-3 text-left md:text-center" data-id="element-71">
          <p data-id="element-72">
            <strong className="text-brand-greenDark" data-id="element-73">P.D.:</strong> Si tenés
            dudas, escribinos a{' '}
            <a href="mailto:soportelumenakasha@gmail.com" className="text-brand-celesteDark hover:underline font-medium" data-id="element-74">
              soportelumenakasha@gmail.com
            </a>{' '}
            o a{' '}
            <a href="https://instagram.com/lumen.akasha" className="text-brand-celesteDark hover:underline font-medium" data-id="element-75">
              @lumen.akasha
            </a>
            . Te respondemos hoy.
          </p>
          <p className="italic text-brand-green" data-id="element-76">
            El precio de lanzamiento sube pronto. El mejor momento para tener tu
            sistema clínico es ahora.
          </p>
        </div>
      </div>
    </Section>;
};